var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ErrorFeedback, SuccessFeedback, showFeedback } from "./Feedback";
export var renderSuccessfulSubmission = function (formElement, message) {
    showFeedback(__assign(__assign({}, SuccessFeedback), { message: message }), formElement, formElement.offsetHeight, formElement.offsetWidth);
};
export var renderFailedSubmission = function (formElement, message) {
    showFeedback(__assign(__assign({}, ErrorFeedback), { message: message }), formElement, formElement.offsetHeight, formElement.offsetWidth);
};
